/**
 * Press Box — the single-team stats module (2026-10-17).
 * The name lives here and only here: rename the module by changing NAME.
 * Routes stay /press-box (signed in) and /stats/<token> (public page).
 */
export const PRESS_BOX = Object.freeze({
  NAME: 'Press Box',
  // 2026-10-19 — the model that checks every game has a name of its own.
  AI_NAME: 'Press Box AI',
  TAGLINE: 'Recordings in, stats out — checked by Press Box AI, shared with the parents.',
});

/** Who sees the nav entry: the `pressBox` feature flag, or the super admin (the server re-checks). */
export const pressBoxVisible = (user) => !!(user?.featureFlags?.pressBox || user?.role === 'admin');

/**
 * 2026-10-18 — the slim menu a standalone Press Box team gets instead of the
 * full team nav (one place so all four layouts agree). Icons are passed in
 * because the layouts own their lucide imports.
 */
// 2026-10-22 (per Gilles) — the full Press Box menu: Games, Stats, Publish,
// Season, Roster, Settings. Icons are passed in so this file stays
// icon-library-free; entries without an icon are skipped.
export const pressBoxNavItems = (team, icons) => {
  const { Radio, Users, Settings, BarChart3, Globe, Trophy } = icons;
  return [
    { to: `/press-box/${team.id}`, icon: Radio, label: 'Games', accent: 'gold', end: true },
    ...(BarChart3 ? [{ to: `/press-box/${team.id}/stats`, icon: BarChart3, label: 'Stats' }] : []),
    ...(Globe ? [{ to: `/press-box/${team.id}/publish`, icon: Globe, label: 'Publish' }] : []),
    ...(Trophy ? [{ to: `/press-box/${team.id}/season`, icon: Trophy, label: 'Season' }] : []),
    { to: `/press-box/${team.id}/roster`, icon: Users, label: 'Roster' },
    { to: `/press-box/${team.id}/settings`, icon: Settings, label: 'Site & Settings' },
  ];
};

export const PRIVACY_LABELS = Object.freeze({
  numbers: 'Jersey numbers only (#12)',
  initials: 'Numbers and initials (#12 R.N.)',
  first_name: 'Numbers and first names (#12 Riley N.)',
});

/**
 * 2026-10-21 (per Gilles) — the model shown to users wears the product's
 * name, not the vendor's: gemma4:31b → "Press Box AI v_G431b". The super
 * admin's Stats AI page keeps the raw model names (that's configuration).
 */
export const modelAlias = (m) => {
  if (!m) return null;
  const s2 = String(m);
  const fam = (s2.match(/^[a-z]+/i) || [''])[0];
  const code = (fam[0] || 'M').toUpperCase() + s2.slice(fam.length).replace(/[^0-9a-z.]/gi, '');
  return `${PRESS_BOX.AI_NAME} v_${code}`;
};
